import {
  ACCOUNT_REVIEW,
  CHEQUE_REVIEW,
  OVERALL_COST,
  OVERALL_COST_DETAIL,
  BALANCE_SHEET_LIST,
  BALANCE_SHEET_DETAIL,
  CASH_FLOW,
  HASHTAG_ACTIVITY,
  HASHTAG_DETAIL_REVIEW,
  CONTACT_ACTIVITY,
  CONTACT_DETAIL_REVIEW
} from "../constants/sectionTypes";
import {
  DEFAULT_APPENDIX,
  SORT_FIELDS,
  SORT_TYPES,
  SORTS
} from "../constants/filters";

export const GetDate = (date, url = false) => {
  if (url) {
    return date ? date.split("/").join("-") : null;
  } else {
    return date ? date.split("-").join("/") : null;
  }
};
export const GetMainType = type => {
  return type ? parseInt(type) : 1;
};

export const GetCreatorUserList = user_list => {
  if (user_list) {
    if (parseInt(user_list) === -1) {
      return [];
    } else {
      return [parseInt(user_list)];
    }
  } else {
    return [];
  }
};
export const GetList = list => {
  if (list) {
    return list ? list.split(",") : list;
  } else {
    return [];
  }
};

export const GetSubject = list => {
  if (list && list !== "-1") {
    return list.split(",").join("");
  } else {
    return "";
  }
};

export const GetIdsList = ids => {
  if (ids) {
    let list = ids.split(",");
    if (list.length === 1 && parseInt(list[0]) === 0) {
      return [];
    }
    list = list.map(item => {
      if (parseInt(item) === -1) {
        return null;
      } else {
        return parseInt(item);
      }
    });
    return list;
  } else {
    return [];
  }
};

export const GetSortField = (sort_field, section_type) => {
  if (sort_field) {
    return sort_field;
  }
  switch (section_type) {
    case ACCOUNT_REVIEW:
      return SORTS.DATE.name;
    case OVERALL_COST_DETAIL:
      return SORTS.DATE.name;
    case OVERALL_COST:
      return SORTS.NAME.name;
    case HASHTAG_ACTIVITY:
      return SORTS.HASHTAG_COLOR.name;
    case HASHTAG_DETAIL_REVIEW:
      return SORTS.DATE.name;
    case CONTACT_ACTIVITY:
      return SORTS.CONTACT_NAME.name;
    case CONTACT_DETAIL_REVIEW:
      return SORTS.DATE.name;
    default:
      return undefined;
  }
};

export const GetSortType = (sort_type, section_type) => {
  if (sort_type) {
    return sort_type;
  } else {
    switch (section_type) {
      case OVERALL_COST:
      case CONTACT_ACTIVITY:
      case HASHTAG_ACTIVITY:
        return SORT_TYPES.ASCENDING.key;
      default:
        return SORT_TYPES.DESCENDING.key;
    }
  }
};

export const GetTextSearch = text_search => {
  if (text_search) {
    return text_search;
  } else {
    return "";
  }
};

export const GetUseHasAppendix = hasAppendix => {
  const intForHasAppendix = parseInt(hasAppendix);
  if (isNaN(intForHasAppendix) || intForHasAppendix === DEFAULT_APPENDIX.key) {
    return null;
  } else {
    return Boolean(intForHasAppendix);
  }
};
export const GetFlag = flag => {
  return flag === "true";
};

export const GetImprestStateList = (list, defaultFilter) => {
  if (list && list !== "-1") {
    return list.split(",").map(item => parseInt(item));
  } else if (list === "-1") {
    return [];
  } else {
    // default
    return defaultFilter.map(state => state.key);
  }
};
